// export const getUserToken = () => {
//     const apiToken = Cookies.get('token');
//     return apiToken
// }


// export const generateHeaders = () => {
//     return {
//         "Content-Type": "application/json",
//         "Authorization": `Bearer ${getUserToken()}`
//     }
// }


// export const getBaseUrl = () => {
//     return process.env.BASE_API_URL
// }


// export const isValidEmail = (email) => {
//     const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return re.test(email);
// };


// import Cookies from 'js-cookie';

// // old
// export const getUserToken = () => {
//     const apiToken = Cookies.get('token');
//     return apiToken
// }

// export const generateHeaders = () => {
//     return {
//         "Content-Type": "application/json",
//         "Authorization": `Bearer ${getUserToken()}`
//     }
// }
// helpers.js - Versão simplificada (sem Cookies)
export const getUserToken = () => {
    return localStorage.getItem('token');
}

export const generateHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : ""
    }
}

export const getBaseUrl = () => {
    return process.env.REACT_APP_BASE_API_URL
}

export const isValidEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
};

// NOVAS FUNÇÕES PARA RESOLVER CORS:

// Opção A: Função fetch com proxy automático
export const apiFetch = async (endpoint, options = {}) => {
    const baseUrl = getBaseUrl();
    // const baseUrl = "https://binarybucks.com"

    // Para desenvolvimento, use caminho relativo (proxy)
    // Para produção, use URL completa
    const url = process.env.NODE_ENV === 'development'
        ? `/api/proxy${endpoint}`  // Via API route do Next.js
        : `${baseUrl}${endpoint}`; // Direto em produção

    try {
        const response = await fetch(url, {
            ...options,
            headers: {
                ...generateHeaders(),
                ...options.headers,
            },
            credentials: 'include', // Importante para cookies
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('API request failed:', error);
        throw error;
    }
}

// Opção B: Função mais simples para CORS
export const fetchWithCORS = async (url, options = {}) => {
    const config = {
        mode: 'cors', // Explicitamente define modo CORS
        credentials: 'include',
        headers: generateHeaders(),
        ...options
    };

    try {
        const response = await fetch(url, config);

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}